import React, { Component } from 'react'
import { extendObservable } from 'mobx'
import { inject, observer } from 'mobx-react'
import { Route, withRouter } from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import PropTypes from 'prop-types'

import ClientContactSearchStore from './client-contact-search.store'

import ClientContactSearchPanel from './ClientContactSearchPanel'
import ClientContactPage from '@root/ClientContact/ClientContactPage'

class ClientContactSearchPage extends Component {
  static propTypes = {
    staticData: PropTypes.object,
    growlStore: PropTypes.object,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string
      }).isRequired,
      url: PropTypes.string
    }).isRequired
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      clientContactSearchStore: new ClientContactSearchStore(
        props.staticData,
        props.growlStore
      )
    })
  }

  render () {
    const { match } = this.props
    const store = this.clientContactSearchStore
    const baseUrl = match.url
    return (
      <DocumentTitle title='Client contact search and listing | Atheneum Partners'>
        <div className='expert-search'>
          <ClientContactSearchPanel
            baseUrl={baseUrl}
            clientContactSearchStore={store}
          />
          <div className='expert-search-results'>
            <Route
              path={`${baseUrl}/client-contact/:id`}
              render={props => (
                <ClientContactPage
                  {...props}
                  clientContactSearchStore={store}
                />
              )}
            />
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default inject(
  'growlStore',
  'staticData'
)(withRouter(observer(ClientContactSearchPage)))
